import type { InscritoPresenca } from '../types';
import { diaMesHora, ehOutroDia, horaCurta, quandoMarcou } from '../presencaFormacao';

interface Props {
  linha: InscritoPresenca;
  formacaoQuando?: string | null;
}

// Linha pequena, embaixo do nome, dizendo quem marcou a presença e quando.
export default function QuemMarcou({ linha, formacaoQuando }: Props) {
  if (linha.como === 'qr') {
    const h = horaCurta(linha.registrada_em);
    return (
      <div className="space-y-0.5">
        <p className="text-xs text-foreground-600">
          Pelo QR, na conta dela{h ? ` · ${h}` : ''}
        </p>
        {linha.observacao && (
          <p className="text-xs italic text-foreground-600">&ldquo;{linha.observacao}&rdquo;</p>
        )}
      </div>
    );
  }

  if (linha.como === 'foto') {
    const quando = diaMesHora(quandoMarcou(linha));
    return (
      <div className="space-y-0.5">
        <p className="text-xs text-foreground-600">
          Por foto enviada por <strong>{linha.registrada_por_nome || 'conta sem nome'}</strong>
          {linha.avaliada_por_nome ? ` · aprovada por ${linha.avaliada_por_nome}` : ''}
          {quando ? ` · ${quando}` : ''}
        </p>
        {linha.observacao && (
          <p className="text-xs italic text-foreground-600">&ldquo;{linha.observacao}&rdquo;</p>
        )}
      </div>
    );
  }

  if (linha.como === 'direcao') {
    const quando = diaMesHora(quandoMarcou(linha));
    const outroDia = ehOutroDia(quandoMarcou(linha), formacaoQuando);
    const registrante = linha.registrada_por_nome || 'conta sem nome';
    // Alguém da direção marcou de novo a mesma pessoa (avaliou quem outro registrou).
    const confirmouDeNovo =
      linha.avaliada_por_nome &&
      linha.registrada_por_nome &&
      linha.avaliada_por_nome !== linha.registrada_por_nome
        ? linha.avaliada_por_nome
        : null;
    return (
      <div className="space-y-0.5">
        <p className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-600">
          <span>
            Marcada pela direção: <strong>{registrante}</strong>
            {quando ? ` · ${quando}` : ''}
            {confirmouDeNovo && (
              <>
                {' · confirmada de novo por '}
                <strong>{confirmouDeNovo}</strong>
              </>
            )}
          </span>
          {outroDia && (
            <span className="rounded-full bg-red-100 px-1.5 py-0.5 text-[10px] font-semibold text-red-700">
              outro dia
            </span>
          )}
        </p>
        {linha.observacao && (
          <p className="text-xs italic text-foreground-600">&ldquo;{linha.observacao}&rdquo;</p>
        )}
      </div>
    );
  }

  return null;
}